import http from "./http";

const post = (url, data) => http.post(url, Object.assign(data));

const get = (url, data) => http.get(url, Object.assign(data));

const getAuthToken = (params) => get("/auth/token", params);
const getAuthorize = (params) => get("/auth/authorize", params);
const getUserInfo = (params) => get("/my/info", params);
const getAgentInfo = (params) => get("/my/agent/preview", params);
const bindUser = (params) => post("/user/bind", params);
const modifyUserInfo = (params) => post("/my/modify", params);
const getOrderInfo = (params) => get("/user/order/info", params);
const modifyOrderNote = (params) => post("/user/order/modify/note", params);
const activeCourse = (params) => post("/user/course/active", params);
const getUpgradeInfo = (params) => get("/agent/upgrade/info", params);
const inviteUser = (params) => post("/agent/invite", params);
const getUserInfoWithCode = (params) => get("/user/info", params);

export {
    getAuthToken,
    getAuthorize,
    getUserInfo,
    getAgentInfo,
    bindUser,
    modifyUserInfo,
    getOrderInfo,
    modifyOrderNote,
    activeCourse,
    getUpgradeInfo,
    inviteUser,
    getUserInfoWithCode
};
